var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Vue from 'vue';
import Theme from '../../../raccoonTheme';
import { roundAt } from "../../../lib/numberUtils";
import { getXemRate } from "../../../lib/exchangeUtils";
import { Decimal } from 'decimal.js';
import MessageDialog from "../../parts/MessageDialog";
import { WalletsHelper } from "../../../lib/storage";
import BalanceModule from "../../mixins/BalanceModule";
import TransactionModule from "../../mixins/TransactionModule";
export default Vue.extend({
    mixins: [BalanceModule, TransactionModule],
    components: { MessageDialog },
    name: "HomeView",
    props: {
        needsUpdate: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            styles: {
                xemAmount: {
                    fontSize: 'x-large',
                    textAlign: 'left',
                    marginLeft: '16px'
                },
                xemUnit: {
                    textAlign: 'right',
                    marginRight: '16px',
                    color: Theme.textDarkGray
                },
                jpyAmount: {
                    textAlign: 'right',
                    marginTop: '-8px',
                    marginRight: '16px',
                    color: Theme.textDarkGray
                },
                transactionIcon: {
                    backgroundColor: Theme.nemBlue,
                    padding: '16px',
                    marginTop: '-8px',
                    marginRight: '16px',
                    height: '90%',
                },
                harvestIcon: {
                    backgroundColor: Theme.primary,
                    padding: '4px',
                    marginTop: '-8px',
                    marginRight: '16px',
                    height: '32px',
                },
            },
            loadingBalance: true,
            loadingRate: true,
            loadingTransaction: true,
            fiat: 0,
            rate: 0,
            transactions: [],
            harvests: []
        };
    },
    methods: {
        updatedFiat() {
            this.fiat = roundAt(new Decimal(this.balance).mul(this.rate).toNumber(), 3).toNumber();
        },
        updatedTransactions() {
            this.transactions = (this.confirmedTransactions || []).filter((value, index) => index < 4);
        },
        update() {
            return __awaiter(this, void 0, void 0, function* () {
                this.loadingBalance = this.loadingRate = this.loadingTransaction = true;
                const activeWallet = yield WalletsHelper.getActive();
                if (activeWallet == null) {
                    this.fiat = 0;
                    this.transactions = [];
                    this.loadingBalance = this.loadingRate = this.loadingTransaction = false;
                    return;
                }
                // Balance
                yield this.fetchBalance(false, () => {
                    this.updatedFiat();
                    this.loadingBalance = false;
                });
                // Fiat
                getXemRate().then((rate) => {
                    this.rate = rate;
                    this.updatedFiat();
                    this.loadingRate = false;
                });
                yield this.fetchTransactions(10, false, () => {
                    this.updatedTransactions();
                    this.loadingTransaction = false;
                });
            });
        }
    },
    mounted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.update();
        });
    },
    watch: {
        needsUpdate: function (needs) {
            return __awaiter(this, void 0, void 0, function* () {
                if (needs) {
                    yield this.update();
                }
            });
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/top/Home.vue
// module id = 392
// module chunks = 1